<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <banked-header :title="title" :path="path" :text1="text1" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <banked-filter :getSelectedValues="getSelectedUsers"
        :downloadUsers="downloadUsersData"></banked-filter>
      <!-- /Search Filter -->


      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getUsers()" style="outline: none">
                <option value="12">12</option>
                <option value="28">28</option>
                <option value="52">52</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="usersData" :pagination="false"
                v-if="usersData.length">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'name'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.profile_image_path)" alt="User Image"
                          v-if="record.profile_image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                      <action-dropdown @banked-time="showBankedTime" :employee="record" variant="text" :reportAsEvent="true" @edit="editEmployeeClicked" @leaves="leavesClicked" 
                        @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @face-templates="faceTemplatesClicked" @toggle-monitoring="monitorClicked" @report="viewReport"
                        @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked"/>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'locations'">
                    <span v-for="(item, index) in record.locations" :key="index" class="inline-item">
                      <span v-if="index > 0">,</span>{{ item.name }}
                    </span>
                  </template>
                  <template v-else-if="column.key === 'accepted_banked_time'">



                    {{ record.accepted_banked_time ? toTimeString(record.accepted_banked_time) : 0 }}

                  </template>

                  <template v-else-if="column.key === 'banked_time_user'">

                    {{ record.banked_time_user ? 'Yes' : 'No' }}

                  </template>

                  <template v-else-if="column.key === 'action'">
                    <div>
                      <!-- class="text-end" -->
                      <div class="dropdown dropdown-action">
                        <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#view_banked_time_details_modal" @click="showBankedTime(record)"><i
                              class="fa-solid fa-eye m-r-5"></i> View</a>
                          <a class="dropdown-item" href="javascript:;" @click="addUserToBankedTime(record.id)"
                            v-if="!ifUserIsBankedTimeUSer(record.id)"><i class="fa-solid fa-plus m-r-5"></i>Add User To
                            Banked Time</a>
                          <a class="dropdown-item" href="javascript:;" @click="removeUserToBankedTime(record.id)"
                            v-else><i class="fa-solid fa-minus m-r-5"></i>Remove User From Banked Time</a>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No employee have been added.</p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
                  show-less-items class="mt-3 " :showSizeChanger="false">
                  <template #itemRender="{ type, originalElement }">
                    <a v-if="type === 'prev'">Previous</a>
                    <a v-else-if="type === 'next'">Next</a>
                    <component :is="originalElement" v-else></component>
                  </template>
                </a-pagination>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <view-banked-time-details-modal ref="showBankedTime"></view-banked-time-details-modal>
    <leaves-admin-modal ref="leaveAdmin"></leaves-admin-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUsers"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getUsers"></assign-employee-modal>

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { getImage, minToTimeString, formatDateTimeStandardLong } from "@/utils/util-funcitons";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import { monitorMixin } from "@/mixins/monitorMixin";
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Banked Time",
    dataIndex: "accepted_banked_time",
    key: "accepted_banked_time",
    // sorter: true,
  },
  {
    title: "Location",
    dataIndex: "locations",
    key: "locations",
    // sorter: true,
  },
  {
    title: "Banked time user",
    dataIndex: "banked_time_user",
    key: "banked_time_user",
    sorter: {
      compare: (a, b) => {
        const valA = a.banked_time_user || '';
        const valB = b.banked_time_user || '';
        return valA.localeCompare(valB);
      },
    },
  },
  {
    title: "Action",
    // sorter: true,
    key: "action",
  },
];


export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    const today = new Date();
    const endOfYear = new Date(today.getFullYear(), 11, 31);
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    return {
      columns,
      title: "Banked Time",
      path: "Dashboard",
      text1: "Banked Time",
      usersData: [],
      bankedTimeUserList: [],
      perPage: 12,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      company_role_id: "",
      companyId: [],
      loader: false,
      selectedUsersFromFilter: [],
      dateRange: {
        start_date: dayjs(firstDayOfYear).format('YYYY-MM-DD'),
        end_date: dayjs(endOfYear).format('YYYY-MM-DD'),
      },
      selectedImageUrl: "",
      selectedEmployeeName: ""
    };
  },
  mounted() {
    this.getUsers(),
      this.getBankedTimeUserList()
  },

  methods: {
    getImage,
    getSelectedUsers(users, date) {
      this.selectedUsersFromFilter = users || null;
      this.dateRange.start_date = date.start_date;
      this.dateRange.end_date = date.end_date;
      this.current = 1;

      this.getUsers();
    },

    showBankedTime(item) {
      this.$refs.showBankedTime.updateValues(item, this.dateRange);
    },

    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    getUsers() {
      this.loader = true;
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      const params = {
        per_page: this.perPage,
        user_ids: this.selectedUsersFromFilter,
        start_date: this.dateRange.start_date,
        end_date: this.dateRange.end_date
      }
      axios.get(`${VUE_APP_API_BASE_URL}/task/list?page=${this.current}`, { params: params })
        .then((response) => {

          if (response.data.status) {
            this.usersData = response.data.data.data;
            this.current = response.data.data.current_page;

            this.total = response.data.data.total;

            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
              element["us_date"] = element["date"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    getBankedTimeUserList() {
      axios.get(`${VUE_APP_API_BASE_URL}/banked-time/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.bankedTimeUserList = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {

        });
    },

    ifUserIsBankedTimeUSer(userId) {
      const user = this.bankedTimeUserList.find(u => u.id === userId);

      return user?.banked_time_user === userId;
    },

    downloadUsersData() {
      const params = {
        user_ids: this.selectedUsersFromFilter,
        start_date: this.dateRange.start_date,
        end_date: this.dateRange.end_date
      }
      axios.post(`${VUE_APP_API_BASE_URL}/banktime-user-list-pdf/download`, params,
        {
          responseType: 'blob'
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'banked_time_user_list.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$toast.error(error.data.errors || 'Download failed');
          console.error('Download failed:', error);
        })
        .finally(() => {
        });
    },


    async addUserToBankedTime(userId) {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/user/add`, { user_id: userId })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.getUsers();
            this.getBankedTimeUserList()
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async removeUserToBankedTime(userId) {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/user/remove`, { user_id: userId })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.getUsers();
            this.getBankedTimeUserList()
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },



    formatDate(dateString) {
      const date = new Date(dateString);
      // Then specify how you want your dates to be formatted
      return formatDateTimeStandardLong(date);
    },

    editEmployeeClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    openImagePreview(record) {
      if (record.profile_image_path) {
        this.selectedImageUrl = this.getImage(record.profile_image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      this.selectedEmployeeName = record.name;
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },
    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.dateRange.start_date, this.dateRange.end_date);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },
  }
}
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

.table-responsive {
  height: 100vh;
  overflow: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

/* .custom-select {
  min-width: 30px;
} */

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>
